import TextArea from "Components/TextArea";
import DropDownBox from "Components/Common/DropDownBox";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { fetchAssetDetails, getPrimaryModeOfFailure } from "../../Redux/Slices/failureAnalysisReqSlice";
import { uploadSingle } from "../../Redux/Slices/mainSlice";
import { RiDeleteBin5Line } from "react-icons/ri";
import "./styles.scss";
import ImageModal from "Components/ImageModal";
import TextEditor from "Components/RichTextArea";
import InputBox from "Components/InputBox";
import ImageEditorTest from "Components/ImageEditor";

const AssetDetails = ({ id, onDataChange, setExist, bearingLength }) => {
  const dispatch = useDispatch();
  const [primaryOptions, setPrimaryOptions] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [bearingComponents, setBearingComponents] = useState([
    {
      id: 1,
      primaryValue: null,
      imgAndObservationContainers: [
        { id: Date.now(), selectedImage: null, imgObservation: "" },
      ],
      observations: [{ id: Date.now(), obs: "" }],
    },
  ]);

  const dropDownStyles = {
    control: (provided) => ({
      ...provided,
      border: "1px solid #B2BEC3",
      borderRadius: "7px",
      padding: "4px",
      boxShadow: "none",
      minHeight: "50px",
      height: "50px",
      cursor: "pointer",
      marginTop: "10px",
      fontFamily: "Poppins",
      fontSize: "14px",
    }),
    option: (provided, state) => ({
      ...provided,
      fontFamily: "Poppins",
      backgroundColor: state.isSelected
        ? "#1F2155"
        : state.isFocused
          ? "#e9ecef"
          : "#fff",
      color: state.isSelected ? "#fff" : "#000",
      padding: 10,
      "&:hover": {
        backgroundColor: state.isSelected
          ? "#1F2155"
          : state.isFocused
            ? "#e9ecef"
            : "#fff",
        color: state.isSelected ? "#fff" : "#000",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "black",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: "#121212",
      padding: "0 8px",
    }),
  };

  const bearingOptions = Array.from({ length: bearingLength }, (_, index) => ({
    label: `Bearing - ${index + 1}`,
    value: index + 1
  }))

  const generateUniqueId = (() => {
    let counter = 0;
    return () => {
      counter += 1;
      return `${Date.now()}-${counter}`;
    };
  })();

  const transformApiData = (data) => {
    const transformedData = data?.map(item => ({
      id: item?.mode_of_failure_id,
      bearingOption: {
        label: item?.bearing_number ? `Bearing - ${item?.bearing_number}` : "",
        value: item?.bearing_number,
      },
      bearingName: item?.bearing_name || "",
      primaryValue: {
        value: item?.primary_mode_of_failure_id,
        label: item?.primary_mode_of_failure_type_name
      },
      imgAndObservationContainers: item?.kgu_image_with_failure_observations.length > 0
        ? item?.kgu_image_with_failure_observations.map(img => ({
          id: generateUniqueId(),
          selectedImage: img?.imgUrl,
          imgObservation: img?.img_cause_of_failure
        }))
        : [
          {
            id: generateUniqueId(),
            selectedImage: null,
            imgObservation: "", // Always ensure at least one textarea exists
          }
        ],
      observations: item.kgu_descriptions.length > 0
        ? item.kgu_descriptions.map(obs => ({
          id: generateUniqueId(),
          obs: obs?.description_text
        })) : [{ id: generateUniqueId(), obs: "" }]
    }));

    console.log(transformedData, 'transformedData')
    setBearingComponents(transformedData);
    onDataChange(transformedData);
  };

  useEffect(() => {
    dispatch(
      getPrimaryModeOfFailure({
        callBack: (data) => {
          const primaryList = data?.data?.map((item) => ({
            label: item?.primary_mode_of_failure_type_name,
            value: item?.primary_mode_of_failure_id,
          }));
          setPrimaryOptions(primaryList);
        },
      })
    );
    dispatch(
      fetchAssetDetails({
        data: {
          remote_failure_details_id: id
        },
        callBack: (data) => {
          console.log(data?.data, 'preview')
          if (data?.data?.length > 0) {
            setExist(true)
            transformApiData(data?.data);
          }
          else {
            setBearingComponents([
              {
                id: 1,
                primaryValue: null,
                imgAndObservationContainers: [
                  { id: Date.now(), selectedImage: null, imgObservation: "" },
                ],
                observations: [{ id: Date.now(), obs: "" }],
              }
            ])
          }
        }
      })
    )
  }, []);

  const addBearingComponent = () => {
    setBearingComponents([
      ...bearingComponents,
      {
        id: Date.now(),
        bearingOption: null,
        bearingName: "",
        primaryValue: null,
        imgAndObservationContainers: [
          { id: Date.now(), selectedImage: null, imgObservation: "" },
        ],
        observations: [{ id: Date.now(), obs: "" }]
      },
    ]);
    onDataChange(bearingComponents)
  };

  const deleteBearingComponent = (id) => {
    const updatedComponents = bearingComponents.filter((comp) => comp.id !== id);
    setBearingComponents(updatedComponents);
    onDataChange(updatedComponents);
  };

  const updateBearingComponent = (id, field, value) => {
    console.log("bearAssets", bearingComponents)
    const updatedComponents = bearingComponents.map((comp) =>
      comp.id === id ? { ...comp, [field]: value } : comp
    );
    setBearingComponents(updatedComponents);
    onDataChange(updatedComponents);
  };

  const handleFileChange = (bearingId, containerId, file) => {
    setSelectedFile({ bearingId, containerId, file });
  };

  const handleFileSave = (bearingId, containerId, file) => {
    const formData = new FormData();
    formData.append("file", file);
    const uploadCB = (value) => {
      const updatedComponents = bearingComponents.map((comp) =>
        comp.id === bearingId
          ? {
            ...comp,
            imgAndObservationContainers: comp.imgAndObservationContainers.map(
              (container) =>
                container.id === containerId
                  ? { ...container, selectedImage: value.data.url }
                  : container
            ),
          }
          : comp
      );
      setBearingComponents(updatedComponents);
      onDataChange(updatedComponents);
    };

    dispatch(
      uploadSingle({
        data: formData,
        callBack: uploadCB,
      })
    );
  };

  const addImgAndObservationContainer = (bearingId) => {
    setBearingComponents(
      bearingComponents.map((comp) =>
        comp.id === bearingId
          ? {
            ...comp,
            imgAndObservationContainers: [
              ...comp.imgAndObservationContainers,
              { id: generateUniqueId(), selectedImage: null, imgObservation: "" }
            ]
          }
          : comp
      )
    );
    onDataChange(bearingComponents);
  };


  const deleteImgAndObservationContainer = (bearingId, containerId) => {
    const updatedComponents = bearingComponents.map((comp) => {
      if (comp.id === bearingId) {
        const updatedContainers = comp.imgAndObservationContainers.filter(
          (container) => container.id !== containerId
        );

        return {
          ...comp,
          imgAndObservationContainers:
            updatedContainers.length > 0 ? updatedContainers : [
              { id: generateUniqueId(), selectedImage: null, imgObservation: "" }
            ]
        };
      }
      return comp;
    });

    setBearingComponents(updatedComponents);
    onDataChange(updatedComponents);
  };

  const addObservation = (bearingId) => {
    setBearingComponents(
      bearingComponents.map((comp) =>
        comp.id === bearingId
          ? { ...comp, observations: [...comp.observations, { id: Date.now(), obs: "" }] }
          : comp
      )
    );
    onDataChange(bearingComponents)
  };

  const deleteObservation = (bearingId, observationId) => {
    const updatedComponents = bearingComponents.map((comp) =>
      comp.id === bearingId
        ? {
          ...comp,
          observations: comp.observations.filter((obs) => obs.id !== observationId),
        }
        : comp
    );
    setBearingComponents(updatedComponents);
    onDataChange(updatedComponents);
  };

  const updateObservation = (bearingId, observationId, value) => {
    const updatedComponents = bearingComponents.map((comp) =>
      comp.id === bearingId
        ? {
          ...comp,
          observations: comp.observations.map((observation) =>
            observation.id === observationId ? { ...observation, obs: value } : observation
          ),
        }
        : comp
    );
    setBearingComponents(updatedComponents);
    onDataChange(updatedComponents);
  };

  return (
    <>
      <div>
        {bearingComponents.map((component) => (
          <div key={component.id} className="bearing-component-container-asset">
            <div className="investigation-section">
              <div className="header-section-asset">
                <label className="investigationLabel">Primary Mode of Failure</label>
                {bearingComponents.length > 1 && (
                  <div
                    onClick={() => deleteBearingComponent(component.id)}
                    className="deleteIcon"
                  >
                    <RiDeleteBin5Line size={20} color="red" />
                  </div>
                )}
              </div>
              <DropDownBox
                options={bearingOptions}
                value={component.bearingOption || null}
                onChange={(value) =>
                  updateBearingComponent(component.id, "bearingOption", value)
                }
                placeholder="Select Bearing Component"
                customStyles={dropDownStyles}
              />

              <InputBox
                inputStyle={{ marginTop: "10px", border: "1px solid #B2BEC3" }}
                value={component.bearingName || ""}
                onChange={(e) =>
                  updateBearingComponent(component.id, "bearingName", e.target.value)
                }
                placeholder="Enter Bearing Name"
              />
              <DropDownBox
                options={primaryOptions}
                value={component.primaryValue}
                onChange={(value) =>
                  updateBearingComponent(component.id, "primaryValue", value)
                }
                placeholder="Select Mode of Failure"
                customStyles={dropDownStyles}
              />
            </div>

            {component.imgAndObservationContainers.map((container) => (
              <div key={container.id} className="imgAndObservationContainerAssets">
                <div>
                  <label className="investigationLabel">Upload Image</label>
                  <input
                    type="file"
                    accept="image/*"
                    id={`fileInput-${container.id}`}
                    style={{ display: "none" }}
                    onChange={(event) =>
                      handleFileChange(
                        component.id,
                        container.id,
                        event.target.files[0]
                      )
                    }
                  />
                  <button
                    type="button"
                    className="uploadButton"
                    onClick={() =>
                      document.getElementById(`fileInput-${container.id}`).click()
                    }
                  >
                    Upload
                  </button>
                  {container.selectedImage && (
                    <div style={{ marginTop: "20px" }}>
                      <ImageModal
                        src={container.selectedImage}
                        alt="FailureComponentsImages"
                        onDelete={() => {
                          const input = document.getElementById(`fileInput-${container.id}`);
                          if (input) input.value = "";
                          const updatedComponents = bearingComponents.map((comp) =>
                            comp.id === component.id
                              ? {
                                ...comp,
                                imgAndObservationContainers: comp.imgAndObservationContainers.map(
                                  (cont) =>
                                    cont.id === container.id
                                      ? { ...cont, selectedImage: null }
                                      : cont
                                ),
                              }
                              : comp
                          );
                          setBearingComponents(updatedComponents);
                          onDataChange(updatedComponents);
                        }}
                      />
                    </div>
                  )}

                  {/* {container.selectedImage && (
                  <>
                  <div style={{ marginTop: "20px" }}>
                    <ImageModal src={container.selectedImage} alt="FailureComponentsImages" />
                  </div>
                    {container.selectedImage && (
                      <p style={{ marginTop: "1rem" }}>
                        {container.selectedImage.split("---").pop()}
                        <span
                          style={{
                            color: "red",
                            marginLeft: "10px",
                            fontSize: "16px",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            const updatedComponents = bearingComponents.map((comp) =>
                              comp.id === component.id
                                ? {
                                  ...comp,
                                  imgAndObservationContainers: comp.imgAndObservationContainers.map(
                                    (cont) =>
                                      cont.id === container.id
                                        ? { ...cont, selectedImage: null }
                                        : cont
                                  ),
                                }
                                : comp
                            );
                            setBearingComponents(updatedComponents);
                            onDataChange(updatedComponents);
                          }}
                        >
                          X
                        </span>
                      </p>
                    )}
                  </>
                )} */}
                </div>
                <TextEditor
                  placeholder="Enter Image Observation Here (Max 100 characters)"
                  name="imgObservation"
                  // maxLength={3000} 
                  value={container.imgObservation}
                  onChange={(e) => {
                    const updatedComponents = bearingComponents.map((comp) =>
                      comp.id === component.id
                        ? {
                          ...comp,
                          imgAndObservationContainers:
                            comp.imgAndObservationContainers.map((cont) =>
                              cont.id === container.id
                                ? { ...cont, imgObservation: e.target.value }
                                : cont
                            ),
                        }
                        : comp
                    );
                    setBearingComponents(updatedComponents);
                    onDataChange(updatedComponents)
                  }
                  }
                />
                {component.imgAndObservationContainers.length > 1 && (
                  <div
                    onClick={() =>
                      deleteImgAndObservationContainer(component.id, container.id)
                    }
                    className="deleteIcon"
                  >
                    <RiDeleteBin5Line size={20} color="red" />
                  </div>
                )}
              </div>
            ))}
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <button
                type="button"
                className="add-button"
                onClick={() => addImgAndObservationContainer(component.id)}
              >
                Add Image
              </button>
            </div>
            {component.observations.map((observation) => (
              <div key={observation.id} className="observation-container-asset">
                <TextEditor
                  placeholder="Enter Description Here"
                  value={observation.obs}
                  onChange={(e) =>
                    updateObservation(component.id, observation.id, e.target.value)
                  }
                // maxLength={600} 
                />
                {component.observations.length > 1 && (
                  <div
                    onClick={() => deleteObservation(component.id, observation.id)}
                    className="deleteIcon"
                  >
                    <RiDeleteBin5Line size={20} color="red" />
                  </div>
                )}
              </div>
            ))}
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <button
                type="button"
                className="add-button"
                onClick={() => addObservation(component.id)}
              >
                Add Description Here
              </button>
            </div>
          </div>
        ))}
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <button
            type="button"
            className="add-button"
            onClick={addBearingComponent}
            style={{ backgroundColor: '#1f2155', margin: '0px 10px 20px 0px' }}
          >
            Add Primary Mode of Failure
          </button>
        </div>
      </div>
      {selectedFile && (
        <div className="modalOverlay">
          <div className="modalContent">
            <ImageEditorTest
              file={selectedFile.file}
              bearingId={selectedFile.bearingId}
              containerId={selectedFile.containerId}
              onSave={(editedFile) => handleFileSave(selectedFile.bearingId, selectedFile.containerId, editedFile)}
              onClose={() => setSelectedFile(null)}
            />

          </div>
        </div>
      )}
    </>
  );
};

export default AssetDetails;
